import { render, staticRenderFns } from "./NewInvestmentCard.vue?vue&type=template&id=2e503ddb&"
import script from "./NewInvestmentCard.vue?vue&type=script&lang=js&"
export * from "./NewInvestmentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports